/**
 * Farmhouse Family Signup - JavaScript
 * Handles variant detection, form validation, and submission
 *
 * DOUBLE OPT-IN (TASK-SEC10-farmhouse-family-double-opt-in): a submit only
 * triggers a "please confirm" email; the shopper joins when they click it.
 * The hidden `website` field is a honeypot for bots.
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    appsScriptUrl: 'https://script.google.com/macros/s/AKfycbz8NPG3C5G9KFIAvL1no3zDTYuz8ajZ1fdY_dUsxXQQsLhZi3awBecFrM1fs_jfajyi-Q/exec',
    defaultVariant: '1'
  };

  // Get variant from URL parameter
  function getVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variant = urlParams.get('variant');
    return variant && ['1', '2', '3'].includes(variant) ? variant : CONFIG.defaultVariant;
  }

  // Show the active variant, hide others
  function showVariant(variantNumber) {
    const variants = document.querySelectorAll('.variant');
    variants.forEach(variant => {
      const variantNum = variant.getAttribute('data-variant');
      if (variantNum === variantNumber) {
        variant.classList.add('active');
        variant.style.display = '';
      } else {
        variant.classList.remove('active');
        variant.style.display = 'none';
      }
    });
  }

  // Form validation
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  function validateForm(formData) {
    const errors = [];

    if (!formData.firstName || formData.firstName.trim().length < 2) {
      errors.push({ field: 'firstName', message: 'Please enter your first name' });
    }

    if (!formData.lastName || formData.lastName.trim().length < 2) {
      errors.push({ field: 'lastName', message: 'Please enter your last name' });
    }

    if (!formData.email || !validateEmail(formData.email)) {
      errors.push({ field: 'email', message: 'Please enter a valid email address' });
    }

    if (!formData.birthday) {
      errors.push({ field: 'birthday', message: 'Please enter your birthday' });
    }

    // Marketing consent is always true - no validation needed

    return errors;
  }

  function showFieldErrors(form, errors) {
    // Clear existing errors
    form.querySelectorAll('.error').forEach(el => el.classList.remove('error'));
    form.querySelectorAll('.form-error').forEach(el => el.remove());

    // Show new errors
    errors.forEach(error => {
      const field = form.querySelector(`[name="${error.field}"]`);
      if (field) {
        field.classList.add('error');
        const errorMsg = document.createElement('div');
        errorMsg.className = 'form-error';
        errorMsg.textContent = error.message;
        field.parentNode.appendChild(errorMsg);
      }
    });
  }

  function clearFieldErrors(form) {
    form.querySelectorAll('.error').forEach(el => el.classList.remove('error'));
    form.querySelectorAll('.form-error').forEach(el => el.remove());
  }

  // UI State Functions
  function showLoadingState(button) {
    button.classList.add('loading');
    button.disabled = true;
    button.setAttribute('data-original-text', button.textContent);
    button.textContent = 'Processing...';
  }

  function hideLoadingState(button) {
    button.classList.remove('loading');
    button.disabled = false;
    const originalText = button.getAttribute('data-original-text');
    if (originalText) {
      button.textContent = originalText;
      button.removeAttribute('data-original-text');
    }
  }

  function showSuccessMessage(variant) {
    const form = variant.querySelector('.family-signup-form');
    const successMsg = variant.querySelector('.success-message');

    if (form && successMsg) {
      form.style.display = 'none';
      successMsg.style.display = 'block';
    }
  }

  function showErrorMessage(variant, message) {
    alert(message || 'Something went wrong. Please try again or contact support.');
  }

  // Form submission handler
  function handleFormSubmit(event, variant, variantNumber) {
    event.preventDefault();

    const form = event.target;
    const submitButton = form.querySelector('.btn-submit, .btn-warm, .btn-bold');

    // Collect form data
    const formData = {
      signup_type: 'farmhouse-family',
      firstName: form.querySelector('[name="firstName"]').value.trim(),
      lastName: form.querySelector('[name="lastName"]').value.trim(),
      email: form.querySelector('[name="email"]').value.trim(),
      birthday: form.querySelector('[name="birthday"]').value,
      marketingConsent: true, // Always true - checkbox is permanently checked
      // Honeypot (TASK-SEC10-farmhouse-family-double-opt-in): hidden from people,
      // filled by bots. Apps Script silently drops any signup where it is set.
      website: (form.querySelector('[name="website"]') || { value: '' }).value,
      variant: variantNumber,
      timestamp: new Date().toISOString()
    };

    // Validate
    const errors = validateForm(formData);
    if (errors.length > 0) {
      showFieldErrors(form, errors);
      return;
    }

    // Clear any previous errors
    clearFieldErrors(form);

    // Show loading state
    showLoadingState(submitButton);

    // Call Apps Script endpoint (using no-cors mode like wholesale forms)
    fetch(CONFIG.appsScriptUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'text/plain'
      },
      body: JSON.stringify(formData)
    })
    .then(function() {
      // With no-cors, we can't read the response, so assume success. The
      // success message asks the shopper to confirm by email: nothing is
      // subscribed until they click the link (double opt-in).
      console.log('Signup submitted successfully');
      hideLoadingState(submitButton);
      showSuccessMessage(variant);
    })
    .catch(function(error) {
      console.error('Signup error:', error);
      hideLoadingState(submitButton);
      showErrorMessage(variant, 'Network error. Please try again or contact support.');
    });
  }

  // Initialize
  function init() {
    // Detect and show variant
    const variantNumber = getVariantFromURL();
    showVariant(variantNumber);

    // Set up form handlers
    const variants = document.querySelectorAll('.variant');
    variants.forEach(variant => {
      const variantNum = variant.getAttribute('data-variant');
      const form = variant.querySelector('.family-signup-form');

      if (form) {
        form.addEventListener('submit', (e) => handleFormSubmit(e, variant, variantNum));
      }
    });

    console.log(`Farmhouse Family signup initialized - Variant ${variantNumber}`);
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
